import React from 'react';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { translate } from 'react-i18next';
import { MenuItem } from 'material-ui/Menu';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router-dom';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Exit from 'material-ui/svg-icons/action/exit-to-app';
import Settings from 'material-ui/svg-icons/action/settings';

class UserMenu extends React.Component {
  handleLogout = () => {
    this.props.firebase.auth().signOut();
  }

  render()  {
    const {t} = this.props;
    return (
        <IconMenu
          iconStyle={{color: 'white'}}
          iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}>
          <MenuItem
            primaryText={t('settings')}
            containerElement={<Link to='/settings' />}
            leftIcon={<Settings />}/>
          <MenuItem
            primaryText={t('logout')}
            leftIcon={<Exit />}
            onTouchTap={this.handleLogout}/>
        </IconMenu>
    );
  }

}
const enhance = compose(translate(), firebase, user);

export default enhance(UserMenu);



// WEBPACK FOOTER //
// ./src/Navigation/UserMenu.js